export default "__VITE_ASSET__DhrwMt2Q__"